const SUCCESS_STATUSES = new Set(["succeeded", "success", "paid", "complete", "completed"]);

export function isPaymentStatusSuccess(status) {
  if (status == null) return false;
  return SUCCESS_STATUSES.has(String(status).trim().toLowerCase());
}

export function paymentFailureMessage(body, fallback = "Payment was not successful.") {
  return body?.failureMessage || body?.failureCode || fallback;
}
